
import {
    defineMessages,
} from 'react-intl'


const messages = defineMessages({
    "search_placeholder": {
        id: 'invoice.listing.search_placeholder',
        defaultMessage: 'Search an invoice...',
    },
    "customer_type_placeholder": {
        id: 'invoice.listing.customer_type_placeholder',
        defaultMessage: 'Customer type',
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: 'ID'
    },
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    },
    "updated_at": {
        id: 'invoice.listing.filters.date.updated_at',
        defaultMessage: 'Updated date',
    },
    "status": {
        id: "invoice.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "sellerId": {
        id: "invoice.listing.headers.seller_id",
        defaultMessage: "User id",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "currency": {
        id: "invoice.listing.headers.currency",
        defaultMessage: "Currency",
    },
    "tax_id": {
        id: "invoice.listing.headers.tax_id",
        defaultMessage: "Tax",
    },
    "product_id": {
        id: "invoice.listing.headers.product_id",
        defaultMessage: "Product",
    },
    "product_label": {
        id: "invoice.listing.headers.product_label",
        defaultMessage: "Product label",
    },
    "product_title": {
        id: "invoice.listing.headers.product_title",
        defaultMessage: "Product title",
    },
    "product_sku": {
        id: "invoice.listing.headers.product_sku",
        defaultMessage: "Product sku",
    },
    "pr_list_title": {
        id: "pricing_list.listing.headers.title",
        defaultMessage: "Title",
    },
    "share_title": {
        id: "pricing_list.listing.headers.share_title",
        defaultMessage: "Share title",
    },
    "share_description": {
        id: "pricing_list.listing.headers.share_description",
        defaultMessage: "Share description",
    },
    "last_order_at": {
        id: "pricing_list.listing.headers.last_order_at",
        defaultMessage: "Last order at",
    },
    "activated_at": {
        id: "pricing_list.listing.headers.activated_at",
        defaultMessage: "Activated at",
    },
    "deactivated_at": {
        id: "pricing_list.listing.headers.deactivated_at",
        defaultMessage: "Deactivated at",
    },
    "number_of_order": {
        id: "pricing_list.listing.headers.number_of_order",
        defaultMessage: "Number of orders",
    },
    "amount_of_order": {
        id: "pricing_list.listing.headers.amount_of_order",
        defaultMessage: "Amount of orders",
    },
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "date_related_filters": {
        id: "invoice.listing.headers.date_related_filters",
        defaultMessage: "Date related filters",
    },
    "contact_related_filters": {
        id: "invoice.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
    "payment_related_filters": {
        id: "invoice.listing.headers.payment_related_filters",
        defaultMessage: "Payment related filters",
    },
    "product_related_filters": {
        id: "invoice.listing.headers.product_related_filters",
        defaultMessage: "Product related filters",
    },
    "other_filters": {
        id: "invoice.listing.headers.other_filters",
        defaultMessage: "Other filters",
    },
})

export const pricingListTotals = [
    'amountOfOrders',
    'numberOfOrders',
]

export const pricingListFields = [
    'identifier',
    'title',
    'titleKeyword',
    'titleAnalyzed',
]

export const getPricingListFilters = function (context) {

    return (
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'userId',
                label: context.intl.formatMessage(messages["sellerId"]),
                filterMatch: 'sellerId',
                type: 'select',
                typeOfSelect: 'user-select',
                placeHolder: 'Select User',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'locationId',
                label: context.intl.formatMessage(messages["location"]),
                filterMatch: 'locationId',
                type: 'select',
                typeOfSelect: 'location-select',
                placeHolder: 'Select Location',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'statuses',
                label: context.intl.formatMessage(messages["status"]),
                type: 'select',
                filterMatch: 'status',
                typeOfSelect: 'pricelist-status-select',
                placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'lastOrderAt',
                label: context.intl.formatMessage(messages["last_order_at"]),
                filterMatch: 'lastOrderAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: "title",
                label: context.intl.formatMessage(messages["pr_list_title"]),
                filterMatch: 'titleKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "shareTittle",
                label: context.intl.formatMessage(messages["share_title"]),
                filterMatch: 'shareTitleKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "shareDescription",
                label: context.intl.formatMessage(messages["share_description"]),
                filterMatch: 'shareDescriptionKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'activatedAt',
                label: context.intl.formatMessage(messages["activated_at"]),
                filterMatch: 'activatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'deactivatedAt',
                label: context.intl.formatMessage(messages["deactivated_at"]),
                filterMatch: 'deactivatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["date_related_filters"]),
            },
            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'createdAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'updatedAt',
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["product_related_filters"]),
            },
            {

                nameId: "productId",
                label: context.intl.formatMessage(messages["product_id"]),
                filterMatch: 'rows.id',
                filterMatchNotOneOf: 'rowsObject.id',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "productTitle",
                label: context.intl.formatMessage(messages["product_title"]),
                filterMatch: 'rows.title',
                filterMatchNot: 'rowsObject.title',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "productSku",
                label: context.intl.formatMessage(messages["product_sku"]),
                filterMatch: 'rows.sku',
                filterMatchNot: 'rowsObject.sku',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {

                nameId: "productLabel",
                label: context.intl.formatMessage(messages["product_label"]),
                filterMatch: 'rows.labelIds',
                filterMatchNotOneOf: 'rowsObject.labelIds',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-label-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                section: context.intl.formatMessage(messages["other_filters"]),
            },
            {
                nameId: "numberOfOrders",
                label: context.intl.formatMessage(messages["number_of_order"]),
                filterMatch: 'numberOfOrders',
                type: 'number',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "amountOfOrders",
                label: context.intl.formatMessage(messages["amount_of_order"]),
                filterMatch: 'amountOfOrders',
                type: 'number',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'currency',
                label: context.intl.formatMessage(messages["currency"]),
                filterMatch: 'currency',
                type: 'select',
                typeOfSelect: 'currency-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'taxID',
                label: context.intl.formatMessage(messages["tax_id"]),
                filterMatch: 'taxId',
                type: 'select',
                initialValue: [],
                typeOfSelect: 'tax-select',
                initialSelect: 'isOneOf'
            },
            {
                nameId: "identifier",
                label: context.intl.formatMessage(messages["identifier"]),
                filterMatch: 'identifier',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]
    )
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/pricingListFilters.jsx